<template>
  <div>
    <div v-if="!isHasAssessment && step === 1">
      <div class="damage-form-title">Damage Assessment & Estimate</div>
      <div class="damage-form-subtitle">Review and set the assessment requirements</div>
      <div class="d-flex">
        <div class="card col-lg-4 col-12">
          <div class="card-header bg-navyblue">
            Insurance / Private
          </div>
          <div class="form-group row" style="padding-top: 15px">
            <label for="is_total_loss" class="col-sm-4 col-4 col-form-label">Insurance Repairer Job</label>
            <div class="col-sm-8 col-8 d-flex insurer-block-mobile">
              <div class="checkbox-p">
                <label class="form-check-inline radio">
                  <input
                      v-model="insuranceRepairerJob"
                      class="form-check-input"
                      type="radio"
                      name="insurance_repairer_job_yes" id="insurance_repairer_job_yes" ref="insurance_repairer_job_yes"
                      value="yes" @click="(!!insuranceRepairerJob)?insuranceRepairerJob=null:null"
                      @keyup.enter.prevent="insuranceRepairerJob = 'yes'"
                      @keydown.tab.prevent="$emit('onTab', 'insurance_repairer_job_yes')">
                  <span class="icon" id="insurance_repairer_yes_label"><i class='bx bx-check'></i></span><span
                    class="text">Yes</span>
                </label>
              </div>
              <div class="checkbox-p">
                <label class="form-check-inline radio">
                  <input class="form-check-input" v-model="insuranceRepairerJob" type="radio"
                         id="insurance_repairer_job_no" ref="insurance_repairer_job_no" name="insurance_repairer_job_no"
                         value="no" @keyup.enter.prevent="insuranceRepairerJob = 'no'"
                         @click="(!insuranceRepairerJob)?insuranceRepairerJob=null:null"
                         @keydown.tab.prevent="$emit('onTab', 'insurance_repairer_job_no')">
                  <span class="icon" id="insurance_repairer_no_label"><i class='bx bx-check'></i></span><span
                    class="text">No</span>
                </label>
              </div>
              <div class="checkbox-p">
                <label class="form-check-inline radio">
                  <input class="form-check-input" v-model="insuranceRepairerJob" type="radio"
                         id="insurance_repairer_job_other" ref="insurance_repairer_job_other"
                         name="insurance_repairer_job_other" value="other"
                         @keyup.enter.prevent="insuranceRepairerJob = 'other'"
                         @click="(!insuranceRepairerJob)?insuranceRepairerJob=null:null"
                         @keydown.tab.prevent="$emit('onTab', 'insurance_repairer_job_other')">
                  <span class="icon" id="insurance_repairer_other_label"><i class='bx bx-check'></i></span><span
                    class="text">Other</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="is_total_loss" class="col-sm-4 col-4 col-form-label">Insurance Claim Type</label>
            <div class="col-sm-8 col-8 d-flex insurer-block-mobile">
              <div class="checkbox-p">
                <label class="form-check-inline radio">
                  <input class="form-check-input" v-model="insuranceClaimType" type="radio"
                         name="insurance_claim_type_insured" id="insurance_claim_type_insured"
                         ref="insurance_claim_type_insured" value="true"
                         @click="(!!insuranceClaimType)?insuranceClaimType=null:null"
                         @keyup.enter.prevent="insuranceClaimType = 'insured'"
                         @keydown.tab.prevent="$emit('onTab', 'insurance_claim_type_insured')"
                  >
                  <span class="icon" id="insurance_claim_type_insured_label"><i class='bx bx-check'></i></span><span
                    class="text">Insured</span>
                </label>
              </div>
              <div class="checkbox-p">
                <label class="form-check-inline radio">
                  <input class="form-check-input" v-model="insuranceClaimType" type="radio"
                         id="insurance_claim_type_other" ref="insurance_claim_type_other"
                         name="insurance_claim_type_other"
                         value="false" @keyup.enter.prevent="insuranceClaimType = 'other'"
                         @click="(!insuranceClaimType)?insuranceClaimType=null:null"
                         @keydown.tab.prevent="$emit('onTab', 'insurance_claim_type_other')"
                  >
                  <span class="icon" id="insurance_claim_type_other_label"><i class='bx bx-check'></i></span><span
                    class="text">Other Party</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="is_total_loss" class="col-sm-4 col-4 col-form-label">Total Loss</label>
            <div class="col-sm-8 col-8 d-flex insurer-block-mobile">
              <div class="checkbox-p">
                <label class="form-check-inline radio">
                  <input v-model="isTotalLoss"
                         id="total_less_y" ref="total_less_y" :value="true"
                         @click="(!!isTotalLoss)?isTotalLoss=null:null"
                         @keyup.enter.prevent="isTotalLoss = 'true'"
                         @keydown.tab.prevent="$emit('onTab', 'total_less_y')"
                         class="form-check-input"
                         type="radio" name="card_is_total_loss">
                  <span class="icon" id="total_less_y_label"><i class='bx bx-check'></i></span><span
                    class="text">Yes</span>
                </label>
              </div>
              <div class="checkbox-p">
                <label class="form-check-inline radio">
                  <input ref="total_less_n"
                         v-model="isTotalLoss"
                         :value="false"
                         @click="(!isTotalLoss)?isTotalLoss=null:null"
                         class="form-check-input" name="card_is_total_loss" type="radio" id="total_less_n">
                  <span class="icon" id="total_less_n_label"><i class='bx bx-check'></i></span><span
                    class="text">No</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="insurance_name" class="col-sm-4 col-4 col-form-label">Insurer Name</label>
            <div class="col-sm-8 col-8 insurer-block-mobile" :class="{'error': errorInsurance }">
              <advanced-search ref="test"
                               v-model="insurerName"
                               :searchData="computedInsurers"
                               :searchKey="'insurer_name'"
                               @onTab="$emit('onTab', 'test')"
                               :searchLabel="'Insurer'"
                               @onSelect="setRatesAfterInsuranceChanged"
                               placeholder="Insurer Name"
                               :isCanBeEmpty="true"
                               :sortByName="'insurer_name'"
                               :maxRecords="computedInsurers.length"
                               :isDisabled="insuranceRepairerJob !== 'yes'"
                               class="insurer-name-input"/>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-4 col-form-label">Accident Description</label>
            <div class="col-sm-8 col-8 insurer-block-mobile">
              <textarea style="height: 150px !important;" class="form-control" :readonly="!isStatusActive"
                        v-model="accidentDescription" name="" cols="30" rows="10">
                        </textarea>
            </div>
          </div>
        </div>
        <div class="card col-lg-4 col-12">
          <div class="card-header bg-navyblue">
            Rates
          </div>
          <estimate-rates
              :estimateRates="estimateRates"
              :defaultValues="defaultValues"
              :aiEstimateType="AIEstimateType"
              @autoUpdateRates='handleEstimateRates'
              :card="card"
              :properties="properties"
              :isShowPaintMaterialNotification="false"
              :isInsuranceRepairYes="isInsuranceRepairYes"
          />
          <div class="card-block rs-scroll rs-scroll--x bg-white">
            <div class="form-group row">
              <label for="ai_estimate_type" class="col-sm-3 col-form-label">Estimate Type</label>
              <div class="col-sm-9">
                <multiselect
                    id="ai_estimate_type"
                    v-model="computedAIEstimateType"
                    :options="AIEstimateTypes"
                    :showLabels="false"
                    :option-height="29"
                    :max-height="203"
                    open-direction="top"
                    :close-on-select="true"
                    placeholder="Select State"
                    style="opacity: 1"
                    track-by="key"
                    label="value"
                >
                </multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12 damage-form-tips-block">
          <div class="damage-form-subtitle">Tips</div>
          <div v-if="showTipsA">
            <div style="margin-bottom: 10px">
              Using AI photo analysis for damage assessment streamlines insurance claims
              by quickly and accurately identifying vehicle damage from photos.
            </div>
            <div>
              When you specify the job as insurance and use the correct Australian estimation
              methodology, AI ensures estimates are consistent with insurer guidelines and
              approvals rates. This leads to faster claim approvals, fewer disputes, and more
              precise, compliant repair recommendations - ultimately improving results
              with insurance companies.
            </div>
          </div>
          <div v-else>
            <div style="margin-bottom: 10px">
              When using AI-driven solutions for automotive damage assessment, it's essential
              to first define whether the estimate is for insurance of private (cash) work and
              select the correct Australian estimating methodology (such as Platinum, MTA, or
              insurer-specific times).
            </div>
            <div style="margin-bottom: 10px">
              Modern AI systems can rapidly generate estimates based on visual damage analysis
              and database inputs, but they must be guided by the appropriate ruleset. Insurers
              encourage use of their repair guidelines, labor rates, and approved parts, which
              AI can apply if properly defined.
            </div>
            <div>
              In contrast, private repairs might focus more on customer preferences of cost-effective
              solutions. Setting these parameters at the start helps the AI generate compliant,
              accurate, and transparent estimates, reduces manual corrections, and ensures a smooth
              workflow foe both your team and your clients.
            </div>
          </div>
        </div>
      </div>
      <div class="wizard__buttons col-lg-8 col-12" style="text-align: right; margin-bottom: 38px">
        <button class="btn btn-outline-primary button-cancel" style="margin-right: 50px"
                @click.prevent="delAssesment">Cancel
        </button>
        <button class="btn btn-primary button-next" @click.prevent="clickNextCancel('next')">Next</button>
      </div>
    </div>
    <div v-else-if="!isHasAssessment && step === 2">
      <div class="d-flex justify-content-between">
        <div>
          <div class="damage-form-title">Damage Assessment & Estimate</div>
          <div class="damage-form-subtitle">Select Vehicle identification photos</div>
          <div class="damage-form-subtitle">Identification Count: {{ selectedImages.length }}</div>
        </div>
        <div class="col-lg-4 col-12 damage-form-tips-block" style="bottom: 0">
          <div class="damage-form-subtitle">Tips</div>
          <div v-if="showTipsA" style="margin-bottom: 10px">
            Choose the part images of the vehicle to be analysed. Include, <span style="font-weight: 700">
              VIN / Build plate, Front, Back, Interior, Centre Console</span> images
            and clearly marked up damage for best results in the vehicle identification
            process.
          </div>
          <div v-else style="margin-bottom: 10px">
            When selecting vehicle damage photos for AI assessment, ensure you capture clear,
            well-lit images from multiple angles - including wide shots of the whole panel
            and close-ups of the damage. This helps the AI accurately identify and assess all
            affected areas, leading to more reliable estimates.
          </div>
        </div>
      </div>
      <image-selector :images="images" :path="''" :isSendToEIOWizard="true" @onChange="onImageSelect"
                      class="image-selector-ai">
      </image-selector>
      <div class="wizard__buttons col-lg-8 col-12" style="text-align: right; margin: 30px 0 38px">
        <button class="btn btn-outline-primary button-cancel" style="margin-right: 50px"
                @click.prevent="delAssesment">Cancel
        </button>
        <button class="btn btn-primary button-next" @click.prevent="clickNextCancel('next')">Next</button>
      </div>
    </div>
    <div v-else-if="!isHasAssessment && step === 3" style="position: relative;height: calc(100vh - 440px);">
      <AiAnalysisLoader :valueLoader="valueLoader" :timeRemaining="timeRemaining" :timerSeconds="timerSeconds"/>
    </div>
    <div v-else-if="!isHasAssessment && step === 4">
      <div class="">
        <div>
          <div class="damage-form-title">Damage Assessment & Estimate</div>
        </div>
        <div class="d-flex justify-content-between">
          <div class="damage-form-subtitle">Collision Damage Parts and Repair Table</div>
          <div class="damage-form-subtitle">Identification Count: {{ selectedImages.length }}</div>
        </div>
        <div class="d-flex">
          <div class="damage-form-table">
            <div class="damage-form-table-header">
              <div class="damage-form-table-header-item" style="width: 220px">Part Name</div>
              <div class="damage-form-table-header-item" style="width: 120px">OEM Part Nbr</div>
              <div class="damage-form-table-header-item" style="width: 50px; text-align: center">Qty</div>
              <div class="damage-form-table-header-item" style="width: 100px">Remv/Replc</div>
              <div class="damage-form-table-header-item" style="flex-grow: 1">Notes</div>
              <div class="damage-form-table-header-item" style="width: 150px">Image ID</div>
              <div class="damage-form-table-header-item" style="width: 60px; text-align: center">
                <div>On Report</div>
                <div class="damage-form-table-header-item-on-report-icon">R</div>
              </div>
              <div class="damage-form-table-header-item" style="width: 60px; text-align: center">
                <div>Add Est</div>
                <label style="margin-left: 7.5px; margin-top: 5px" class="form-check-inline checkbox">
                  <input class="form-check-input" name="hide-series-checkbox" type="checkbox" v-model="allCheckedEst"
                         @change="changeAllCheckEst"/>
                  <span class="icon"><i class="bx bx-check"></i></span>
                </label>
              </div>
            </div>
            <div class="damage-form-table-body"
                 v-arrow-nav="{selector:'.form-control'}"
                 @keydown.enter.prevent.capture="onEnterKeyOnTable"
                 @focusin="onFocusInTable"
                 @dblclick="onDoubleClickRow"
                 @contextmenu.prevent="onRightClickRow">

              <div v-for="(part, index) in assessmentParts"
                   :key="index"
                   :data-index="index"
                   class="damage-form-table-body-elem d-flex">
                <input v-if="part.edit" type="text" class="damage-form-table-body-elem-item form-control"
                       style="text-transform: uppercase;width: 220px; font-weight: 700" v-model="part.name">
                <div v-else class="damage-form-table-body-elem-item"
                     style="text-transform: uppercase;width: 220px; font-weight: 700">{{ part.name }}
                </div>
                <input v-if="part.edit" type="text" class="damage-form-table-body-elem-item form-control"
                       style="width: 120px" v-model="part.part_num">
                <div v-else class="damage-form-table-body-elem-item" style="width: 120px">{{ part.part_num }}</div>
                <number-formatter
                    v-if="part.edit"
                    style="width: 50px"
                    type="text"
                    v-model="part.qty"
                    class="noselect form-control numeric numeric-qty"
                    format="0,0"></number-formatter>

                <div v-else class="damage-form-table-body-elem-item" style="width: 50px; text-align: center">
                  {{ part.qty }}
                </div>
                <div class="damage-form-table-body-elem-item" style="width: 100px; font-weight: 700">{{ part.action }}
                </div>
                <div class="damage-form-table-body-elem-item" style="flex-grow: 1;flex-shrink: 1;">{{ part.notes }}
                </div>
                <div class="damage-form-table-body-elem-item" style="width: 150px; color: #3958ff">{{ part.image_name }}
                </div>
                <div class="damage-form-table-body-elem-item" style="width: 60px;">
                  <label class="form-check-inline checkbox">
                    <input class="form-check-input" name="hide-series-checkbox" type="checkbox"
                           v-model="part.checkedReport" @change="(val)=>changeOnReport(val,part)"/>
                    <span class="icon" style="margin: 0 7.5px"><i class="bx bx-check"></i></span>
                  </label>
                </div>
                <div class="damage-form-table-body-elem-item" style="width: 60px;">
                  <label class="form-check-inline checkbox">
                    <input class="form-check-input" name="hide-series-checkbox" type="checkbox"
                           v-model="part.checkedEst"
                           @change="(val)=>changeCheckEst(val,part)"/>
                    <span class="icon" style="margin: 0 7.5px"><i class="bx bx-check"></i></span>
                  </label>
                </div>
              </div>

            </div>
            <vue-context ref="damageFormRightClickMenu" @close="contextClose">
              <ul>
                <li @click="onEditLine">Edit Line</li>
                <li @click="onSetRepair">Set to Repair</li>
                <li @click="onSetReplace">Set to Replace</li>
                <li>Change side reference</li>
              </ul>
            </vue-context>
            <button class="btn btn-primary button-next"
                    style="background-color: white; color: #5d78fd; margin-top: 20px"
                    @click.prevent="addNewPart(null)">
              <i class="ti-plus"></i> New Item
            </button>
          </div>
          <div style=" min-height: 400px; margin-left: 10px" :style="{maxHeight: heightPartsTable - 200 + 'px'}">
            <div class="damaged-parts-tabs-photos-block" v-for="(category,index) in damage?.categorys" :key="index">
              <div class="damaged-parts-tabs-title">{{ category.area }}</div>
              <div class="damaged-parts-tabs-photos">
                <div class="image-list-wrapper">
                  <div
                      v-for="(img, index) in getFilteredImages(category.images)"
                      :key="img.id"
                      class="image-list-image col-sm-3">
                    <div class="box bg-grey img-box">
                      <a
                          @click="openImageGalleryFromPhotos(category.images, index)"
                          class="hand-pointer img-grid__link">
                        <img :src="img.previewW220 || img.src" class="img-fluid">
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wizard__buttons col-12" style="text-align: right; margin: 30px 30px 38px;">
        <span style="margin-right: 20px; margin-top: 10px; font-size: 14px; height: 50px"><span
            style="font-weight: bold">Note:</span> if you CANCEL, a credit will still be applied.</span>
        <button class="btn btn-outline-primary button-cancel" style="margin-right: 50px"
                @click.prevent="delAssesment">Cancel
        </button>
        <button class="btn btn-primary button-next" style="width: 130px" @click.prevent="createEstimate">Create
          Estimate
        </button>
      </div>
    </div>
    <div v-else-if="isHasAssessment || step === 5">
      <damage-assessment-ai
          :images="images"
          :damage="damage"
          @rerun-assessment="$emit('rerun-assessment')"
          @reload-estimate="$emit('reload-estimate')">
      </damage-assessment-ai>
    </div>
    <image-gallery
        v-if="showGallery"
        :images="galleryImages"
        :current-index="galleryIndex"
        :use-editor="false"
        :show-remove="false"

        @close-gallery="closeGallery"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import AdvancedSearch from '@/components/utility/advanced-search.vue'
import AiAnalysisLoader from '@/components/utility/ai-analysis-loader.vue'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import NumberFormatter from '@/components/utility/number-formatter.vue'
import ImageLightbox from '@/components/utility/image-lightbox/image-lightbox'
import Axios from 'axios'
import ImageSelector from '@/components/utility/image-selector.vue'
import GoogleLocation from '@/components/utility/google-location.vue'
import DamageAssessmentAi from './damage-assessment-ai.vue'
import arrowNav from '@/directives/arrow-nav'
import EstimateRates from './../estimate-rates.vue'
import ImageGallery from '@/components/utility/image-lightbox/image-gallery.vue'
import { VueContext } from 'vue-context'

export default {
  name: 'damage-assessment-form',
  directives: { arrowNav },
  components: {
    VueContext,
    ImageGallery,
    GoogleLocation,
    ImageSelector,
    ImageLightbox,
    NumberFormatter,
    Multiselect,
    AdvancedSearch,
    AiAnalysisLoader,
    DamageAssessmentAi,
    EstimateRates,
  },
  props: {
    images: {
      type: Array,
      default () {
        return {}
      }
    },
    insurers: {
      type: Array,
      default () {
        return {}
      }
    },
    assessmentAi: {
      type: [Object, null],
      default () {
        return {}
      }
    },
    estimateId: 0,
    isHasAssessment: false,
    formData: {
      type: Object,
      default: () => ({})
    },
  },
  data: function () {
    return {
      AIEstimateType: 'quick-2',
      AIEstimateTypes: [
        { key: 'quick-2', value: 'Quick Estimate - Hours' },
        { key: 'quick-1', value: 'Quick Estimate - Dollars' },
        { key: 'quick-3', value: 'Quick Estimate - Part On Report', $isDisabled: true },
        { key: 'rb', value: 'Review and Build', $isDisabled: true },
        { key: 'sp', value: 'Standardised Procedures', $isDisabled: true },
      ],
      activeContexItemidx:null,
      contextOpenEvent: null,
      galleryImages: [],
      showGallery: false,
      galleryIndex: 0,
      heightPartsTable: 0,
      timerSeconds: 0,
      hasInitializedTimer: false,
      isUnmounted: false,
      damage: {},
      timeRemaining: 0,
      valueLoader: 0,
      allCheckedEst: false,
      errorInsurance: false,
      step: 1,
      showTipsA: true,
      tipsInterval: null,
      activeRowIndex: null,
      assessmentParts: [],
      selectedImages: [],
      insuranceRepairerJob: '',
      insuranceClaimType: '',
      isTotalLoss: '',
      card: {},
      assessors: {},
      insurerName: '',
      insurerId: 0,
      accidentDescription: '',
      estimateMethodology: '',
      defaultValues: {
        rates: {}
      },
      estimateRates: {
        estimate_methodology: 'custom',
        rr: 95,
        repair: 95,
        paint: 95,
        partmarkup: 55,
        paint_material: 'not_set',
        material_use_levy: 'Y',
        subtotal: 0,
        adjSubtotal: 0,
        mechanical: 0,
        rs_rr_percentage: 20,
        rs_paint_percentage: 20,
      },
      estimateMethodologies: [
        { key: 'custom', value: 'Custom' },
        // ...
      ],
    }
  },
  methods: {
    contextClose: function () {
      if (this.contextOpenEvent) {
        this.setColorForRow(this.contextOpenEvent, '')
      }
    },
    openImageGalleryFromPhotos (categoryImageIds, clickedIndex) {
      this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop

      const ids = new Set((categoryImageIds || []).map(id => Number(id)))
      const filteredImages = (this.damage?.allImages || []).filter(img => ids.has(Number(img.id)))

      this.galleryImages = filteredImages.map(img => ({
        id: img.id,
        url: img.src
      }))

      this.galleryIndex = clickedIndex
      this.showGallery = true
    },
    getFilteredImages (categoryImages) {
      const ids = new Set((categoryImages || []).map(id => Number(id)))
      const list = (this.damage?.allImages || []).filter(img => ids.has(Number(img.id)))
      return list
    },
    handleEstimateRates (data) {
      this.estimateRates = { ...this.estimateRates, ...data.estimateRates }
    },
    onDoubleClickRow (e) {
      const row = e?.target?.closest('.damage-form-table-body-elem')
      if (row && typeof row.dataset.index !== 'undefined') {
        const idx = Number(row.dataset.index)
        if (this.assessmentParts[idx]) {
          this.$set(this.assessmentParts[idx], 'edit', true)
        }
      }
    },
    onRightClickRow (e) {
      this.$refs.damageFormRightClickMenu.open(e)
      this.activeContexItemidx = null
      const row = e?.target?.closest('.damage-form-table-body-elem')
      if (row && typeof row.dataset.index !== 'undefined') {
        const idx = Number(row.dataset.index)
        console.log('onRightClickRow', this.assessmentParts[idx])
        this.activeContexItemIdx = idx
        // if (this.assessmentParts[idx]) {
        //   this.$set(this.assessmentParts[idx], 'edit', true)
        // }
      }
    },
    onEditLine(){
      this.$set(this.assessmentParts[this.activeContexItemIdx], 'edit', true)
    },
    onSetRepair(){
      this.assessmentParts[this.activeContexItemIdx].action = 'Repair'
    },
    onSetReplace(){
      this.assessmentParts[this.activeContexItemIdx].action = 'Replace'
    },
    formattedAiResForViewDamage(res, images) {
      if (!res) return
      const object = _.cloneDeep(res)
      function recalculationAmount(res) {
        let result = res.quote_summary
        result.potential_provisional_cost_total = res.parts.reduce((a, b) => {
          if (b?.assessment_status === 'PROVISIONAL_INFERRED') {
            return a + b.cost
          }
          return a + 0
        },0)
        result.total_confirmed_parts_cost = res.parts.reduce((a, b) => {
          if (b?.assessment_status !== 'PROVISIONAL_INFERRED') {
            return a + b.cost
          }
          return a + 0
        },0)
        result.total_remove_and_replace_cost = res?.labour_assessment['RR'].reduce((a, b) => {
          return a + b.amount
        },0)
        result.total_repair_cost = res?.labour_assessment['Repair'].reduce((a, b) => {
          return a + b.amount
        },0)
        result.total_paint_cost = res?.labour_assessment['Paint'].reduce((a, b) => {
          return a + b.amount
        },0)
        result.total_miscellaneous_cost = res?.miscellaneous_charges.reduce((a, b) => {
          return a + b.cost
        },0)
        return result
      }
      function formatedHistory(history) {
        if (Array.isArray(history) && history.length != 0) {
          history.forEach((item) => {
            item.createdAt = new Date(item.createdAt).toLocaleString('en-AU', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            });
          })
          return history
        }
        return []
      }
      function damagePhotosByCategory (assessment) {
        if (!assessment) return []

        return assessment
            .filter(area => Array.isArray(area.parts) && area.parts.length > 0)
            .map(area => ({
              area: area.area,
              images: [...new Set(area.parts
                  .filter(part => part.image_id)
                  .map(part => part.image_id)
              )]
            }))
      }
      function filterLaborAssesment(res) {
        const obj = res.labour_assessment
        const isQuick2 = res?.AIEstimateType === 'quick-2'
        const mapKeys = { paint: 'Paint', remove_and_replace: 'RR', repair: 'Repair' };
        const order = ['RR', 'Repair', 'Paint'];

        const renamed = Object.entries(obj).reduce((acc, [k, v]) => {
          const nk = mapKeys[k] ?? k;
          acc[nk] = v;
          return acc;
        }, {});

        const out = {};
        for (const key of order) {
          if (key in renamed) out[key] = renamed[key];
        }
        for (const [k, v] of Object.entries(renamed)) {
          if (!(k in out)) out[k] = v;
        }

        for (const key of Object.keys(out)) {
          const val = out[key];
          if (Array.isArray(val)) {
            out[key] = val.map((item) => {
              if(isQuick2){
                return { ...item, cost: res.adjRates[`${key.toLowerCase()}`],
                  amount: res.adjRates[`${key.toLowerCase()}`] * (item?.hours || 0) }
              }else {
                return { ...item, amount: item.cost  }
              }
            }
            );
          }
        }

        return out;
      }

      function getImageName (imageId) {
        const image = result.allImages.find(img => Number(img.id) === Number(imageId))
        return image ? image.w : (image.name?image.name:'')
      }
      function getFinalizeCostPart(part){
          if(part?.oem_list_price && part?.oem_list_price != 0){
            return part.oem_list_price
          }
          if(part?.estimated_price_aud && part?.estimated_price_aud != 0){
            return Number(part.estimated_price_aud) * 1.1
          }

          return 0
      }
      function giveDamageParts (assessment) {
        if (!assessment) return []
        const result = assessment.flatMap((area, areaIndex) => {
          return area.parts.map((part, partIndex) => {
            const reactivePart = {
              ...part,
              severity: area.severity,
              area: area.area,
              areaIndex,
              partIndex,
            }
            return reactivePart
          })
        })
        return result.map(part => ({ ...part, checkedReport: part?.onReport||false, checkedEst: part?.partId||false }))
      }
      function filtredAssessment(assessment) {
        const obj = [ ...assessment ]
        for (const key in obj) {
          obj[key]?.parts.forEach((part) => {
            part.cost = getFinalizeCostPart(part)
            part.image_name = getImageName(part.image_id)
            part.checkedReport = part?.onReport||false,
            part.checkedEst = part?.partId||false
          })
          obj[key].allCheckedEst = obj[key]?.parts.every(part => part.checkedEst) || false
        }
        return obj
      }
      function typeBody (vehicle) {
        console.log('typeBody', vehicle)
        const body = _.get(vehicle, 'body')
        console.log('body', body)
        return _.isEmpty(_.trim(body)) ? 'HATCH' :
            _.toUpper(body) === 'SEDAN' ? 'SEDAN' : 'HATCH'
      }

      function partsForSvg (parts) {
        if (_.isEmpty(parts)) return []
        return _.map(parts, 'area')
      }

      function allImages (assessment, images) {
        if (!images || !assessment) return []
        const allImageEntries = _.flatMap(assessment, area =>
            _.chain(area.parts)
                .filter('image_id')
                .map(part => {
                  const image = _.find(images, img => Number(img.id) === Number(part.image_id))
                  return image ? { ...image, area: area.area, partName: part.name } : null
                })
                .compact()
                .value()
        )

        return _(allImageEntries)
            .groupBy('id')
            .map(group => {
              const baseImage = _.omit(group[0], ['area', 'partName'])
              return {
                ...baseImage,
                areas: _.uniq(_.map(group, 'area')),
                partNames: _.uniq(_.map(group, 'partName'))
              }
            })
            .value()
      }

      let result = { ...object }

      result.history = formatedHistory(object?.history)
      result.categorys = damagePhotosByCategory(object.assessment)
      result.electricalConcerns = object.electrical_systems_check
      result.tyreRimConcerns = object.tyre_rim_condition_check
      result.mechanicalConcerns = object.mechanical_condition_check
      result.typeBody = typeBody(object.vehicle)
      result.allImages = allImages(object.assessment, images)
      result.assessment = filtredAssessment(result.assessment)
      result.parts = giveDamageParts(object.assessment)
      result.partsForSvg = partsForSvg(result.parts)
      result.labour_assessment = filterLaborAssesment(result)
      result.areaForList = {}

      result.quote_summary = recalculationAmount(result)
      console.log('formattedAiResForViewDamage',result)
      return result
    },
    formattedParts (parts) {
      const array = _.cloneDeep(parts)
      array.forEach((part) => {
        part.id = null
      })
    },
    async addPartsInEstimate () {
      try {
        let parts = this.assessmentParts.filter(part => part.checkedEst)
        let newItem = {
          id: null,
          adj_price: null,
          adj_rate: null,
          adj_mup: null,
          name: '',
          part_num: '',
          type: 'New',
          mup: 0,
          qty: 1,
          rate: 0,
          rate2: 0,
          total: 0,
          is_show_in_jobcard: true,
          comments: {},
        }
        parts.forEach((part) => {
          _.defaults(part, newItem)
          part.name = part.name.toUpperCase()
        })
        const promises = parts.map((part) => {
          return Axios({
            method: 'post',
            responseType: 'json',
            headers: { 'addPart': true },
            url: `/fe/estimate/${this.estimateId}`,
            validateStatus: function (status) {
              return status < 500
            },
            data: { part, type: 'Part' }
          })
        })
        const result = await Promise.allSettled(promises)
        result.forEach((res, index) => {
          // console.log('addPartsInEstimate',res)
          if (res.status === 'fulfilled') {
            parts[index].id = res.value.data.result.id
          }
        })
        this.$emit('add-parts', parts)
      } catch (error) {
        console.log('error addPartsInEstimate:', error)
      } finally {

      }
    },
    createEstimate () {
      const partsForEstimate = this.assessmentParts.filter(part => part.checkedEst)
      const partsForReport = this.assessmentParts.filter(part => part.checkedReport)
      this.addPartsInEstimate()
      this.step++
      console.log('partsForEstimate', partsForEstimate)
      console.log('partsForReport', partsForReport)
    },
    onFocusInTable (e) {
      const row = e?.target?.closest('.damage-form-table-body-elem')
      if (row && typeof row.dataset.index !== 'undefined') {
        this.activeRowIndex = Number(row.dataset.index)
      } else {
        this.activeRowIndex = null
      }
    },
    onEnterKeyOnTable (e) {
      const row = e?.target?.closest('.damage-form-table-body-elem')
      let idx = null
      if (row && typeof row.dataset.index !== 'undefined') {
        idx = Number(row.dataset.index)
      } else if (typeof this.activeRowIndex === 'number') {
        idx = this.activeRowIndex
      }
      this.addNewPart(idx)
    },
    addNewPart (index = null) {
      const row = {
        id: null,
        damageArea: '',
        name: '',
        part_num: '',
        qty: 1,
        action: '',
        notes: '',
        checkedReport: false,
        checkedEst: true,
        edit: true,
        adj_price: null,
        adj_rate: null,
        adj_mup: null,
        mup: 0,
        rate: 0,
        rate2: 0,
        total: 0,
        is_show_in_jobcard: true,
        comments: {},

      }
      if (index === null || index === undefined) {
        if (typeof this.activeRowIndex === 'number') {
          index = this.activeRowIndex
        }
      }
      if (index === null || index === undefined) {
        this.assessmentParts.push(row)
      } else {
        this.assessmentParts.splice(index + 1, 0, row)
      }

      this.changeCheckEst()
    },
    changeAllCheckEst (val) {
      const input = val.srcElement.checked
      this.assessmentParts.forEach(part => {
        part.checkedEst = input
        if (!input) {
          part.checkedReport = input
        }
      })
    },
    changeOnReport (val, part) {
      console.log('changeOnReport', val)
      part.checkedEst = val.srcElement.checked
      this.changeCheckEst()
    },
    changeCheckEst (val = null, part = null) {
      if (!val?.srcElement?.checked && part) {
        part.checkedReport = val.srcElement.checked
      }
      const allChecked = this.assessmentParts.every(part => part.checkedEst)
      this.allCheckedEst = allChecked
    },

    setRatesAfterInsuranceChanged (v) {
      this.insurerName = v.insurer_name
      this.insurerId = v.insurer_id
      let rates = v.rates
      console.log('setRatesAfterInsuranceChanged', v)
      this.estimateRates.estimate_methodology = _.toLower(rates.estimate_methodology)
      this.estimateRates.rr = rates.estimate_rates_rr || 0
      this.estimateRates.mechanical = rates.estimate_rates_mechanical || 0
      this.estimateRates.repair = rates.estimate_rates_repair || 0
      if (_.toLower(rates.estimate_methodology) === 'custom') {
        if (this.estimateRates.paint_material == 'not_set' || !(this.estimateRates.paint_material)) {
          this.estimateRates.paint = 0
        } else {
          this.estimateRates.paint = v.custom_paint_times[this.estimateRates.paint_material.toLowerCase()] || 0
        }
      } else {
        this.estimateRates.paint = rates.estimate_rates_paint || 0
      }
      this.estimateRates.rs_rr_percentage = rates.estimate_rates_rs_rr_percentage || this.defaultValues.rates.rs.default_rates_rs_rr_percentage
      this.estimateRates.rs_paint_percentage = rates.estimate_rates_rs_paint_percentage || this.defaultValues.rates.rs.default_rates_rs_paint_percentage
    },
    async delAssesment () {
      this.$emit('del-assessment')
      // try {
      //   const aiQueueId = this.assessmentAi?.aiQueueId
      //   if (aiQueueId) {
      //     const res = await Axios.delete(`/fe/estimate/${this.estimateId}/ai-damage/${aiQueueId}`)
      //     if (res.data._status) {
      //       this.$emit('del-assessment')
      //     }
      //   } else {
      //     this.$emit('del-assessment')
      //   }
      // } catch (error) {
      //   console.log(error)
      // }
    },
    clickNextCancel (type) {
      if (type === 'prev' && this.step === 4) {
        this.step = 1
      }
      if (type === 'prev' && this.step !== 1) {
        this.step--
      }
      if (type === 'next') {

        if (this.insuranceRepairerJob === 'yes') {
          if (!this.isSelectInsurerName) {
            toastr.error('Select Insurer Name')
            this.errorInsurance = true;
            return
          }
        }else{
          this.errorInsurance = false;
        }
        if (this.step === 1 && (this.AIEstimateType == 'quick-1' || this.AIEstimateType == 'quick-2' || this.AIEstimateType == 'quick-3')) {
          this.step = 3;
          this.sendAires(true)
          return
        }
        if (this.insuranceRepairerJob === 'other' && this.step === 1) {
          if (!window.confirm('The damage assessment performs vehicle identification and requires photos of the Build/Compliance plate, front , back ans badging. if these photos are not available. Cancel running this action as the results you require cannot be preoduced')) {
            return
          }
        }
        if (this.step === 2 && !this.isSelectedImage) {
          return
        }
        this.step++
      }
      if (this.step === 3) {
        this.sendAires(true)
      }
    },
    async checkAnswerAi (aiQueueId, mounted = false) {
      if (this.isUnmounted) return
      const res = await Axios.get(`/fe/estimate/${this.estimateId}/ai-damage/${aiQueueId}`)
      const data = res?.data
      const created = data?.queue?.created_at
      const targetDate = new Date(created.replace(' ', 'T'))
      const now = new Date()

      const secondsPassed = Math.floor((now - targetDate) / 1000)
      if (!data?._status) {
        throw new Error('Error while checking answer ai for aiQueueId')
      }
      if (data?.queue.status === 'processing' || data?.queue?.status === 'pending') {

        if (mounted) {
          if (!this.hasInitializedTimer) {
            this.timerSeconds = secondsPassed
            this.hasInitializedTimer = true
          }
          this.valueLoader = Math.floor((secondsPassed / 120) * 100)
        }
        this.timeRemaining = this.timeRemaining + 5
        await new Promise((r) => setTimeout(r, 5 * 1000))

        return this.checkAnswerAi(aiQueueId, mounted)
      }
      if (data?.queue?.status === 'completed') {
        if (!data.queue?.damage) {
          throw new Error('Error while checking answer ai for aiQueueId')
        }
        return data
      }
    },
    async sendAires (forced = false) {
      console.log('sendAires!!!!!!')
      try {
        const aiQueueId = this.assessmentAi?.aiQueueId
        let response
        this.valueLoader = 0
        this.timeRemaining = 60
        this.hasInitializedTimer = false
        if (!aiQueueId || forced) {
          const otherData = this.getStepOneInputData()
          const res = await Axios.post(`/fe/estimate/${this.estimateId}/ai-damage`, {
            imageIds: this.selectedImages,
            rates: otherData?.rates,
            insurance: otherData?.insurance,
            DAType: this.AIEstimateType,
            AIEstimateType: this.AIEstimateType
          })

          this.timeRemaining = res.data?.remainTime || 45

          if (res.data?._status) {
            if (this.isUnmounted) return
            response = await this.checkAnswerAi(Number(res.data?.aiQueueId))
          }

        } else {
          response = await this.checkAnswerAi(aiQueueId, true)
        }
        this.valueLoader = 100

        if (response && response?._status) {
          if (response.queue.damage) {
            // this.damage = this.formattedAiResForViewDamage(response.queue.damage, this.images)
            // this.assessmentParts = this.damage.parts
            this.$emit('update-vehicle')
          }
        }
        setTimeout(() => {
          this.timeRemaining = 0
          if (response?.queue.AIEstimateType == 'quick-1' || response?.queue.AIEstimateType == 'quick-2' || response?.queue.AIEstimateType == 'quick-3') {
            this.step = 5
          } else {
            this.step = 4
          }
        }, 1000)
      } catch (error) {
        this.step--
        toastr.error('Error while sending images to AI. Please try again later.')
        console.error('sendAires:', error)
      }

    },
    getStepOneInputData () {
      try {
        const methodology = this.estimateMethodology
        const methodologyKey = (typeof methodology === 'object' && methodology !== null)
            ? (methodology.key ? methodology.key : null)
            : (methodology ? methodology : null)

        return {
          insurance: {
            insuranceRepairerJob: this.insuranceRepairerJob || null,
            insuranceClaimType: this.insuranceClaimType || null,
            isTotalLoss: this.isTotalLoss,
            insurerName: this.insurerName || null,
            insurerId: this.insurerId || null,
            accidentDescription: this.accidentDescription || null,
          },
          rates: this.estimateRates,
        }
      } catch (e) {
        // Fallback to minimal payload if something unexpected happens
        return {
          insurance: {
            insuranceRepairerJob: this.insuranceRepairerJob || null,
            insuranceClaimType: this.insuranceClaimType || null,
            isTotalLoss: this.isTotalLoss,
            insurerName: this.insurerName || null,
            insurerId: this.insurerId || null,
            accidentDescription: this.accidentDescription || null,
          },
          rates: this.estimateRates,
        }
      }
    },
    addCheckedKey (parts) {
      return parts.map(part => ({ ...part, checkedReport: false, checkedEst: false }))
    },
    onImageSelect: function (imgs) {
      this.selectedImages = imgs
    },
    populateFormFromData () {
      if (!this.formData || Object.keys(this.formData).length === 0) return

      if (this.formData.insurance_repair) {
        if (this.formData.insurance_repair === 'true') {
          this.insuranceRepairerJob = 'yes'
        } else if (this.formData.insurance_repair === 'false') {
          this.insuranceRepairerJob = 'no'
        } else if (this.formData.insurance_repair === '2' || this.formData.insurance_repair === 'other') {
          this.insuranceRepairerJob = 'other'
        }
      }

      // Populate insurance claim type - convert from 'insured'/'other_party' to 'true'/'false'
      if (this.formData.insurance?.insurance_claim_type) {
        const claimType = this.formData.insurance.insurance_claim_type
        if (claimType === 'insured' || claimType === 'Insured') {
          this.insuranceClaimType = 'true'
        } else if (claimType === 'other_party' || claimType === 'Other Party') {
          this.insuranceClaimType = 'false'
        }
      }

      // Populate total loss - handle both boolean and string values
      if (this.formData.isTotalLoss !== undefined && this.formData.isTotalLoss !== null) {
        if (this.formData.isTotalLoss === true || this.formData.isTotalLoss === 'true') {
          this.isTotalLoss = 'true'
        } else if (this.formData.isTotalLoss === false || this.formData.isTotalLoss === 'false') {
          this.isTotalLoss = 'false'
        }
      }

      // Populate insurer name
      if (this.formData.insurance?.insurer_name) {
        this.insurerName = this.formData?.insurance?.insurer_name
        this.insurerId = this.formData?.insurance?.insurer_id
      }

      // Populate accident description
      if (this.formData.insurance?.accidentDescription) {
        this.accidentDescription = this.formData.insurance.accidentDescription
      }

      // Populate rates from card insurance
      if (this.formData.rates) {
        const rates = this.formData.rates
        if (rates.estimate_methodology) {
          const methodology = this.estimateMethodologies.find(m => m.key === rates.estimate_methodology)
          if (methodology) {
            this.estimateMethodology = methodology
            this.estimateRates.estimate_methodology = rates.estimate_methodology
          }
        }
        if (rates.rr !== undefined) this.estimateRates.rr = rates.rr
        if (rates.repair !== undefined) this.estimateRates.repair = rates.repair
        if (rates.paint !== undefined) this.estimateRates.paint = rates.paint
        if (rates.paint_material) {
          const paintMaterialValue = String(rates.paint_material).toUpperCase()
          console.log('Setting paint_material:', paintMaterialValue)
          this.estimateRates.paint_material = paintMaterialValue
        }
        if (rates.partmarkup !== undefined) this.estimateRates.partmarkup = rates.partmarkup
        if (rates.mechanical !== undefined) this.estimateRates.mechanical = rates.mechanical
        if (this.estimateRates.paint_material == "NOT_SET" ||this.estimateRates.paint_material == "not_set"){
          this.estimateRates.paint_material = "S1";
        }
      }

      // Store card reference
      this.card = _.cloneDeep(this.formData)
      console.log('Form populated, estimateRates:', this.estimateRates)
    },
    closeGallery () {
      this.showGallery = false
      this.$nextTick(() => {
        window.scrollTo(0, this.savedScrollPosition)
      })
    },
  },
  mounted () {
    this.isUnmounted = false
    this.tipsInterval = setInterval(() => {
      this.showTipsA = !this.showTipsA
    }, 20000)
    this.populateFormFromData()
  },
  beforeDestroy () {
    this.isUnmounted = true
    if (this.tipsInterval) {
      clearInterval(this.tipsInterval)
      this.tipsInterval = null
    }
  },
  computed: {
    ...mapGetters({
      isStatusActive: 'isStatusActive',
    }),
    computedAIEstimateType: {
      get: function () {
        let vm = this
        try {
          let item = _.find(this.AIEstimateTypes, function (itm) {
            return itm.key.toLowerCase() === vm.AIEstimateType.toLowerCase()
          })
          return item
        } catch (e) {
          return   { key: 'quick', value: 'Quick Estimate - Default' };
        }
      },
      set: function (item) {
        this.AIEstimateType = item.key
      },
    },

    properties () {
      return this.formData.properties || {}
    },
    isInsuranceRepairYes () {
      return this.insuranceRepairerJob === 'yes'
    },
    isSelectedImage () {
      if (this.selectedImages.length === 0 && this.selectedImages.length < 50) {
        toastr.error('Please select from 1 to 50 images.')
      }
      return this.selectedImages.length > 0 && this.selectedImages.length <= 50
    },
    isSelectInsurerName () {
      return this.insurerName !== ''
    },
    computedInsurers () {
      let insurers = this.insurers
      insurers = _.forEach(insurers, function (i) {
        if (i.insurer_name) {
          i.insurer_name = i.insurer_name.trim()
        }
        return i
      })
      insurers = _.sortBy(insurers, [function (insurer) {
        if (insurer.insurer_name) {
          return insurer.insurer_name.trim().toLowerCase()
        }
      }])

      insurers.push({ 'insurer_name': null, id: null })
      return insurers
    },
    isEstimateMethodologyDollars () {
      return this.estimateRates.estimate_methodology == 'dollars'
    },
  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.populateFormFromData()
        }
      }
    },
    assessmentAi: {
      deep: true,
      immediate: true,
      handler (val) {
        const status = val?.status
        if (val.damage) {
          if (val.AIEstimateType == 'quick-1' || val.AIEstimateType == 'quick-2' || val.AIEstimateType == 'quick-3') {
            this.step = 5
          } else {
            this.step = 4
          }
          let damageTemp = {
            ...val,
            ...val.damage,
            history: val?.history,
            estimateId: this.estimateId,
            aiQueueId: val?.aiQueueId,
            AIEstimateType: val?.AIEstimateType,
            adjRates: val?.adjRates
          }
          this.damage = this.formattedAiResForViewDamage(damageTemp, this.images)
          this.assessmentParts = this.damage.parts
        }
        if (!val?.damage && status === 'completed') {
          this.step = 1
          return
        }
        if (!val?.damage && val.aiQueueId && (status === 'processing' || status === 'pending')) {
          this.step = 3
          this.sendAires()
        }
      }
    }
  }

}
</script>
<style>
.insurer-block-mobile.error input {
  border: red solid 1px;
}

.rates-estimates-methodology.error .multiselect__tags {
  border: red solid 1px;
}
</style>
<style scoped>
.damaged-parts-tabs-photos-block {
  margin-top: 20px;
}

.damaged-parts-tabs-photos-block:first-child {
  margin-top: 0;
}

.damaged-parts-tabs-title {
  font-size: 13px;
  font-weight: 600;
  line-height: 24px;
}

.damaged-parts-tabs-photos {
  width: 100%;
  border: 2px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  flex-wrap: wrap;
  padding-top: 10px;
}

.damaged-parts-tabs-photos >>> img {
  width: 100%;
  object-fit: cover;
  height: 120px;
}

.damaged-parts-tabs-photos >>> .image-list-wrapper {
  width: 100%;
  object-fit: cover;
  flex-wrap: wrap;
  display: flex;

}

.damaged-parts-tabs-photos-block:last-child {
  margin-bottom: 30px;
}

.damaged-parts-tabs-photos >>> .image-list-image {
  width: 50%;
}

.damage-form-table {
  padding: 10px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.damage-form-table-header {
  background-color: rgba(27, 30, 56, .1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.damage-form-table-header,
.damage-form-table-body {
  /*  min-width: 1080px; */
  /*  max-width: 1500px; */
}

.damage-form-table-header-item {
  margin: 0 5px;
  padding: 0.75rem;
}

.damage-form-table-body-elem {
  border-bottom: 1px solid rgba(27, 30, 56, .25);
  align-items: center;
}

.damage-form-table-body-elem-item {
  flex-shrink: 0;
  margin: 0 5px;
  padding: 0.75rem;
}

.damage-form-table-body-elem-item.form-control {
  width: auto;
  box-sizing: border-box;
}

.damage-form-table-header-item-on-report-icon {
  color: white;
  background-color: #d09400;
  font-weight: bold;
  height: 20px;
  width: 20px;
  border-radius: 999px;
  font-size: 14px;
  padding: 3px;
  line-height: 16px;
  margin-top: 5px;
  margin-left: 10px;
}

.image-selector-ai >>> .image-selector-header .image-selector__checkbox {
  position: relative;
}

.rates-estimates-methodology.multiselect >>> .multiselect__tags {
  height: 32px;
}

.damage-form-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  color: #1C1F39;
  padding: 15px;
}

.damage-form-subtitle {
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: #1C1F39;
  padding: 10px 15px;
}

.damage-form-tips-block {
  position: relative;
  bottom: 60px;
}

.card-block >>> .multiselect__tags,
.insurer-name-input >>> .register-adv-search-block input{
  cursor: pointer;
}
</style>
